
import { isArray } from 'lodash';
import moment from 'moment';
import { actionCreator } from 'utils';
import * as OrderTypes from '../types/orderTypes';

const prevMonth = moment().subtract(3, 'months');
const startDate = prevMonth.format('YYYY-MM-DD 00:00:00');
const nowDate = moment().format('YYYY-MM-DD 23:59:59');

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 50,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    neededCRMData: {
        productGroups: [],
        configurations: [],
    },
    filters: {
        status: undefined,
        createdAt: [startDate, nowDate],
        source: undefined,
        invoice_created: undefined,
        amount: undefined,
        shop: undefined,
        accountManager: [],
        orderId: '',
        reference: '',
        design: '',
        payment: [],
    },
    view: {
        loading: false,
        error: false,
        data: null,
        isPrintingOfficePopupVisible: false,
        isChangingPrintingOffice: false,
        isAddingPrintingFile: false,
        viewDesignVariantsPopup: false,
        isDownloadingPdf: false,
        isDownloadingOrderItemPdf: false,
        reprint: {
            loading: false,
            error: false,
            success: false,
        },
        clone: {
            loading: false,
            error: false,
            success: false,
        },
        cancel: {
            loading: false,
            error: false,
            success: false,
        },
        items: {
            clone: {
                loading: [],
                error: false,
                success: false,
            },
            delete: {
                loading: [],
                error: false,
                success: false,
            },
            checked: [],
            comment: {
                loading: false,
                error: false,
                success: false,
            },
            link: {
                loading: false,
                error: false,
                success: false,
            },
            document: {
                loading: false,
                error: false,
                success: false,
            },
            changeStatus: {
                loading: false,
                error: false,
                success: false,
            },
        },
        printVersionData: null,
    },
    add: {
        order: {
            loading: false,
            error: false,
            data: null,
        },
        orderItem: {
            loading: false,
            error: false,
            success: false,
        },
        shippingAddress: {
            loading: false,
            error: false,
            success: false,
        },
        additionalItem: {
            loading: false,
            error: false,
            success: false,
        },
        favoris: {
            loading: false,
            error: false,
            success: false,
        },
        payment: {
            loading: false,
            error: false,
            success: false,
        },
        paymentRequest: {
            loading: false,
            error: false,
            success: false,
        },
        discount: {
            loading: false,
            error: false,
            success: false,
        },
        waitingForPayment: {
            loading: false,
            error: false,
            success: false,
        },
    },
    edit: {
        order: {
            loading: false,
            error: false,
        },
        shippingType: {
            loading: false,
            error: false,
            data: null,
        },
        orderItem: {
            loading: false,
            error: false,
            success: false,
        },
        shippingDate: {
            loading: false,
            error: false,
            success: false,
        },
    },
    del: {
        favoris: {
            loading: false,
            error: false,
            success: false,
        },
        payment: {
            loading: false,
            error: false,
            success: false,
        },
        additionalItem: {
            loading: false,
            error: false,
        },
        printingFile: {
            loading: false,
            error: false,
        },
    },
    billingAccount: {
        isPopupVisible: false,
        isSubmitting: false,
        listing: null,
        loading: false,
    },
    invoices: {
        listing: null,
        loading: false,
    },
    listingPaymentTypes: {},
    isPaymentOrderPopupVisible: false,
    isPaymentRequestOrderPopupVisible: false,
    neededData: {
        users: [],
        configurations: [],
        productGroups: [],
        payments: [],
        addresses: [],
    },
};

export default (state = initState, action) => {
    switch (action.type) {
    case OrderTypes.LOAD_ORDERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(OrderTypes.LOAD_ORDERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
            neededCRMData: {
                ...state.neededCRMData,
                ...action.neededCRMData,
            },
        });

    case actionCreator(OrderTypes.LOAD_ORDERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case OrderTypes.SET_ORDERS_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case OrderTypes.SET_ORDERS_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case OrderTypes.SET_ORDERS_FILTER:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case OrderTypes.RESET_ORDERS_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case OrderTypes.LOAD_ORDER:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: true,
                error: false,
            },
        });

    case actionCreator(OrderTypes.LOAD_ORDER, 'res'):
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: false,
                data: action.data,
                isChangingPrintingOffice: false,
            },
        });

    case actionCreator(OrderTypes.LOAD_ORDER, 'err'):
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: false,
                error: true,
                isChangingPrintingOffice: false,
            },
        });

    case OrderTypes.SET_NEEDED_DATA:
        return Object.assign({}, state, {
            neededData: {
                ...state.neededData,
                ...action.data,
            },
        });

    case OrderTypes.SHOW_PRINTING_OFFICE_POPUP:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                isPrintingOfficePopupVisible: true,
            },
        });

    case OrderTypes.HIDE_PRINTING_OFFICE_POPUP:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                isPrintingOfficePopupVisible: false,
            },
        });

    case OrderTypes.CHANGE_PRINTING_OFFICE:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                isChangingPrintingOffice: true,
            },
        });

    case OrderTypes.RESET_ORDERS_INFO:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                data: null,
            },
        });

    case OrderTypes.EDIT_SHIPPING_TYPE_ORDER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.shippingType,
                shippingType: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_SHIPPING_TYPE_ORDER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.shippingType,
                shippingType: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_SHIPPING_TYPE_ORDER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.shippingType,
                shippingType: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.REPRINT_ORDER_ITEM:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                reprint: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(OrderTypes.REPRINT_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                reprint: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(OrderTypes.REPRINT_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                reprint: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case OrderTypes.CLONE_ORDER:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                clone: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(OrderTypes.CLONE_ORDER, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                clone: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(OrderTypes.CLONE_ORDER, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                clone: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case OrderTypes.CANCEL_ORDER:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                cancel: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(OrderTypes.CANCEL_ORDER, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                cancel: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(OrderTypes.CANCEL_ORDER, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                cancel: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case OrderTypes.CLONE_ORDER_ITEM:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    clone: {
                        loading: [
                            ...state.view.items.clone.loading,
                            action.clonedItemId,
                        ],
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.CLONE_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    clone: {
                        loading: state.view.items.clone.loading.filter(c => !action.payload.includes(c)),
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.CLONE_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    clone: {
                        error: true,
                        loading: [],
                    },
                },
            }),
        });

    case OrderTypes.DELETE_ORDER_ITEM:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    delete: {
                        loading: [
                            ...state.view.items.delete.loading,
                            action.orderItemId,
                        ],
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    delete: {
                        loading: state.view.items.delete.loading.filter(c => !action.payload.includes(c)),
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    delete: {
                        error: true,
                        loading: [],
                    },
                },
            }),
        });

    case OrderTypes.SET_CHECKED_ORDER_ITEMS:
        if (state.view.items.checked.includes(action.id)) {
            return Object.assign({}, state, {
                view: Object.assign({}, state.view, {
                    items: {
                        ...state.view.items,
                        checked: [
                            ...state.view.items.checked.filter(c => c !== action.id),
                        ],
                    },
                }),
            });
        }

        if (isArray(action.id)) {
            return Object.assign({}, state, {
                view: Object.assign({}, state.view, {
                    items: {
                        ...state.view.items,
                        checked: action.id.length !== 0 ? action.id : [],
                    },
                }),
            });
        }

        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    checked: [
                        ...state.view.items.checked.filter(c => c !== action.id),
                        action.id,
                        // ...action.data.map(s => s.cost_and_duration_id),
                    ],
                },
            }),
        });

    case OrderTypes.SET_COMMENT_ORDER_ITEMS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    comment: {
                        loading: true,
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.SET_COMMENT_ORDER_ITEMS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    comment: {
                        loading: action.loading,
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.SET_COMMENT_ORDER_ITEMS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    comment: {
                        error: true,
                        loading: false,
                    },
                },
            }),
        });

    case OrderTypes.ADD_LINK_ORDER_ITEMS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    link: {
                        loading: true,
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_LINK_ORDER_ITEMS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    link: {
                        loading: action.loading,
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_LINK_ORDER_ITEMS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    link: {
                        error: true,
                        loading: false,
                    },
                },
            }),
        });

    case OrderTypes.ADD_DOCUMENT_ORDER_ITEMS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    document: {
                        loading: true,
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_DOCUMENT_ORDER_ITEMS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    document: {
                        loading: action.loading,
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_DOCUMENT_ORDER_ITEMS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    document: {
                        error: true,
                        loading: false,
                    },
                },
            }),
        });

    case OrderTypes.DELETE_DOCUMENT_ORDER_ITEMS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    document: {
                        loading: `delete-${action.data.item_id}`,
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_DOCUMENT_ORDER_ITEMS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    document: {
                        loading: false,
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_DOCUMENT_ORDER_ITEMS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    document: {
                        error: true,
                        loading: false,
                    },
                },
            }),
        });


    case OrderTypes.DELETE_LINK_ORDER_ITEMS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    link: {
                        loading: `delete-${action.data.item_id}`,
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_LINK_ORDER_ITEMS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    link: {
                        loading: false,
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_LINK_ORDER_ITEMS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    link: {
                        error: true,
                        loading: false,
                    },
                },
            }),
        });


    case OrderTypes.ADD_NEW_ORDER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                order: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_NEW_ORDER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                order: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_NEW_ORDER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                order: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.EDIT_ORDER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                order: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_ORDER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                order: {
                    loading: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_ORDER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                order: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.ADD_NEW_ORDER_ITEM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                orderItem: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_NEW_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                orderItem: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_NEW_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                orderItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.ADD_ADDITIONAL_ITEM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.additionalItem,
                additionalItem: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_ADDITIONAL_ITEM, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.additionalItem,
                additionalItem: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_ADDITIONAL_ITEM, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.additionalItem,
                additionalItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.DELETE_ADDITIONAL_ITEM:
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.additionalItem,
                additionalItem: {
                    loading: action.data.id,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_ADDITIONAL_ITEM, 'res'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.additionalItem,
                additionalItem: {
                    loading: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_ADDITIONAL_ITEM, 'err'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.additionalItem,
                additionalItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.EDIT_ORDER_ITEM:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                orderItem: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                orderItem: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                orderItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.SET_EXPECTED_SHIPPING_DATE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                shippingDate: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.SET_EXPECTED_SHIPPING_DATE, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                shippingDate: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.SET_EXPECTED_SHIPPING_DATE, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.order,
                shippingDate: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.ADD_NEW_FAVORIS_ORDER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.favoris,
                favoris: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_NEW_FAVORIS_ORDER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.favoris,
                favoris: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_NEW_FAVORIS_ORDER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.favoris,
                favoris: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.DELETE_FAVORIS_ORDER:
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.favoris,
                favoris: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_FAVORIS_ORDER, 'res'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.favoris,
                favoris: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_FAVORIS_ORDER, 'err'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.favoris,
                favoris: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.LOAD_BILLING_ACCOUNT:
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                loading: true,
            },
        });

    case actionCreator(OrderTypes.LOAD_BILLING_ACCOUNT, 'res'):
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                listing: action.data,
                loading: false,
            },
        });

    case actionCreator(OrderTypes.LOAD_BILLING_ACCOUNT, 'err'):
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                loading: false,
            },
        });

    case OrderTypes.ADD_PAYMENT_ORDER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.payment,
                payment: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_PAYMENT_ORDER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.payment,
                payment: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
            isPaymentOrderPopupVisible: false,
        });

    case actionCreator(OrderTypes.ADD_PAYMENT_ORDER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.payment,
                payment: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.PAYMENT_ORDER_POPUP_VISIBILITY:
        return Object.assign({}, state, {
            isPaymentOrderPopupVisible: action.data,
        });

    case OrderTypes.ADD_PAYMENT_REQUEST_ORDER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.paymentRequest,
                paymentRequest: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_PAYMENT_REQUEST_ORDER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.paymentRequest,
                paymentRequest: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
            isPaymentRequestOrderPopupVisible: false,
        });

    case actionCreator(OrderTypes.ADD_PAYMENT_REQUEST_ORDER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.paymentRequest,
                paymentRequest: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.PAYMENT_REQUEST_ORDER_POPUP_VISIBILITY:
        return Object.assign({}, state, {
            isPaymentRequestOrderPopupVisible: action.data,
        });

    case OrderTypes.DELETE_PAYMENT_ORDER:
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.payment,
                payment: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_PAYMENT_ORDER, 'res'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.payment,
                payment: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_PAYMENT_ORDER, 'err'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.payment,
                payment: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.LOAD_PAYMENT_TYPES:
        return Object.assign({}, state, {
            loading: true,
            data: action.data,
        });

    case actionCreator(OrderTypes.LOAD_PAYMENT_TYPES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingPaymentTypes: action.data,
        });

    case actionCreator(OrderTypes.LOAD_PAYMENT_TYPES, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case OrderTypes.LOAD_ORDER_INVOICES:
        return Object.assign({}, state, {
            invoices: {
                ...state.invoices,
                loading: true,
            },
        });

    case actionCreator(OrderTypes.LOAD_ORDER_INVOICES, 'res'):
        return Object.assign({}, state, {
            invoices: {
                ...state.invoices,
                listing: action.data,
                loading: false,
            },
        });

    case actionCreator(OrderTypes.LOAD_ORDER_INVOICES, 'err'):
        return Object.assign({}, state, {
            invoices: {
                ...state.invoices,
                loading: false,
                error: true,
            },
        });

    case OrderTypes.DELETE_PRINTING_FILE:
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.printingFile,
                printingFile: {
                    loading: `${action.data.item_file_id}-${action.data.web_to_print_id}`,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_PRINTING_FILE, 'res'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.printingFile,
                printingFile: {
                    loading: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.DELETE_PRINTING_FILE, 'err'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.printingFile,
                printingFile: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.CHANGE_ORDER_ITEM_STATUS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    changeStatus: {
                        ...state.view.items.changeStatus,
                        changeStatus: {
                            loading: true,
                            error: false,
                        },
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.CHANGE_ORDER_ITEM_STATUS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    changeStatus: {
                        ...state.view.items.changeStatus,
                        changeStatus: {
                            loading: action.loading,
                            success: action.sucess,
                            error: false,
                        },
                    },
                },
            }),
        });

    case actionCreator(OrderTypes.CHANGE_ORDER_ITEM_STATUS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    changeStatus: {
                        ...state.view.items.changeStatus,
                        changeStatus: {
                            loading: false,
                            success: false,
                            error: true,
                        },
                    },
                },
            }),
        });

    case OrderTypes.EDIT_SHIPPING_ADDRESS:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                shippingAddress: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_SHIPPING_ADDRESS, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                shippingAddress: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.EDIT_SHIPPING_ADDRESS, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                shippingAddress: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.CHANGE_BILLING_ACCOUNT:
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                isSubmitting: true,
            },
        });

    case actionCreator(OrderTypes.CHANGE_BILLING_ACCOUNT, 'res'):
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                isSubmitting: false,
                isPopupVisible: false,
            },
        });

    case actionCreator(OrderTypes.CHANGE_BILLING_ACCOUNT, 'err'):
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                isSubmitting: false,
            },
        });

    case OrderTypes.TOGGLE_BILLING_ACCOUNT_POPUP:
        return Object.assign({}, state, {
            billingAccount: {
                ...state.billingAccount,
                isPopupVisible: action.data,
            },
        });

    case OrderTypes.SET_PRINT_VERSION_DATA:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                printVersionData: action.data,
            },
        });

    case OrderTypes.ADD_PRINTING_FILE:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isAddingPrintingFile: true,
            },
        });

    case actionCreator(OrderTypes.ADD_PRINTING_FILE, 'res'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isAddingPrintingFile: false,
            },
        });

    case actionCreator(OrderTypes.ADD_PRINTING_FILE, 'err'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isAddingPrintingFile: false,
            },
        });

    case OrderTypes.SET_VIEW_DESIGN_VARIANTS_POPUP:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                viewDesignVariantsPopup: action.data,
            },
        });

    case OrderTypes.ADD_DISCOUNT_INTO_ORDER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                discount: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_DISCOUNT_INTO_ORDER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                discount: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.ADD_DISCOUNT_INTO_ORDER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                discount: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                waitingForPayment: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                waitingForPayment: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(OrderTypes.CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.order,
                waitingForPayment: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case OrderTypes.DOWNLOAD_ORDER_PDF:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isDownloadingPdf: true,
            },
        });

    case actionCreator(OrderTypes.DOWNLOAD_ORDER_PDF, 'res'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isDownloadingPdf: false,
            },
        });

    case actionCreator(OrderTypes.DOWNLOAD_ORDER_PDF, 'err'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isDownloadingPdf: false,
            },
        });

    case OrderTypes.DOWNLOAD_ORDER_ITEM_PDF:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isDownloadingOrderItemPdf: true,
            },
        });

    case actionCreator(OrderTypes.DOWNLOAD_ORDER_ITEM_PDF, 'res'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isDownloadingOrderItemPdf: false,
            },
        });

    case actionCreator(OrderTypes.DOWNLOAD_ORDER_ITEM_PDF, 'err'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                isDownloadingOrderItemPdf: false,
            },
        });

    default:
        return state;
    }
};
